<template>
  <Dialog
    v-model:visible="popupOpen"
    modal
    :style="{ width: '600px', height: '330px' }"
    class="sendMailDialog"
  >
    <div class="header-container">
      <span class="text-header">{{ staticData.send_premail }}</span>
      <i @click="closePopup" class="pi pi-times cursor-pointer"></i>
    </div>
    <div class="container-bar">
      <span class="text-container">
        {{ staticData.insert_email }}
      </span>
      <div class="grid mt-3">
        <div class="col-12 form-group">
          <label-tooltip
            labelvalue="E-mail address"
            tooltipvalueFor="mail-tooltip"
            labelclass="control-label"
            :isRequiredLabel="true"
          ></label-tooltip>
          <InputRequiredText
            v-model="vmodel.emailAddress"
            :validation="v$.valmodel.emailAddress"
            :IsEmail="true"
            id="Email"
            PropName="Email"
            placeholder="firstname.lastname@company.com"
          ></InputRequiredText>
        </div>
      </div>
    </div>
    <div class="grid col-12 bottom-bar">
      <PrimeButton
        label="Send"
        class="save-btn1 ml-2"
        icon="pi pi-send"
        @click="sendMail"
      ></PrimeButton>
      <PrimeButton
        label="Cancel"
        class="edit-btn ml-2"
        icon="pi pi-times"
        @click="closePopup"
      ></PrimeButton>
    </div>
  </Dialog>
</template>

<script>
import DataLayerService from "@/services/data-layer.service.js";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import LabelTooltip from "@/components/shared/label-tooltip.vue";
import Dialog from "primevue/dialog";
import PrimeButton from "primevue/button";
import InputRequiredText from "@/components/elements/InputRequiredText.vue";
import staticData from "@/staticdata/static.json";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    LabelTooltip,
    Dialog,
    PrimeButton,
    InputRequiredText,
  },
  data() {
    return {
      staticData: staticData.mail,
      vmodel: {
        emailAddress: "",
      },
      valmodel: null,
      visible: false,
    };
  },
  validations() {
    return {
      valmodel: {
        emailAddress: { required, email },
      },
    };
  },
  beforeCreate() {
    this.valmodel = this.vmodel;
  },
  props: {
    ShowPopup: {
      type: Boolean,
      default: false,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
    campaignid: {
      type: String,
      required: true,
    },
    mailType: {
      type: String,
      required: true,
    },
  },
  computed: {
    popupOpen: {
      get() {
        return this.ShowPopup;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    // this.vmodel.emailAddress = this.$store.state.cognitoInfo.email;
  },
  methods: {
    closePopup() {
      this.popupOpen = false;
      this.$emit("closepopup");
    },
    sendMail() {
      this.valmodel = this.vmodel;
      this.v$.valmodel.$touch();
      if (this.v$.valmodel.$pending || this.v$.valmodel.$error) {
        return false;
      }

      DataLayerService.get(
        `/email/Sendtestmail/${this.userType}/${this.campaignid}/${this.mailType}/${this.vmodel.emailAddress}`
      ).then((result) => {
        if (result.success) {
          this.vmodel.emailAddress = "";
          this.v$.valmodel.$reset();
          this.closePopup();
        }
        this.$toast.add({
          detail: result.message,
          severity: "success",
          summary: "Success",
          life: 3000,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  height: 80px;
  padding: 21px 32px 21px 32px;
}

.header-container .pi {
  margin-left: auto;
  cursor: pointer;
}

.text-header {
  font-family: "Voyado Text" !important;
  font-size: 25.63px !important;
  font-weight: 600 !important;
  line-height: 30.76px !important;
  text-align: center !important;
  font-family: "Voyado Display" !important;
}

.container-bar {
  height: 104px;
  padding: 0px 32px 0px 32px;
}

.bottom-bar {
  height: 104px;
  padding: 32px;
  margin-top: 8px;
}

.mt-0 {
  margin-top: 0 !important;
}

.ml-2 {
  margin-left: 0.5rem;
}

.p-dialog-content {
  overflow-y: hidden;
}
.text-container {
  font-family: "Voyado Text" !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 21.6px !important;
  text-align: left !important;
  color: #000000 !important;
}
</style>
